<!-- Sub order start here -->
<ng-container
  *ngIf="
    (orderData.subOrders && orderData.subOrders.length > 0) ||
    oderType.includes(orderData?.type)
  "
>
  <!-- Provide Estimate card start -->
  <div
    *ngIf="orderData?.state?.code === orderStateCode['requested']"
    class="estimate-card mb-3 p-3"
  >
    <div class="estimate-info">
      <div class="estimate-icon">
        <svg
          width="27"
          height="27"
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.1004 19.8002V20.3502C12.1004 20.4969 12.1554 20.6252 12.2654 20.7352C12.3754 20.8452 12.5037 20.9002 12.6504 20.9002H13.7504C13.8971 20.9002 14.0254 20.8452 14.1354 20.7352C14.2454 20.6252 14.3004 20.4969 14.3004 20.3502V19.8002H15.4004C15.7121 19.8002 15.9733 19.6948 16.1841 19.4839C16.395 19.2731 16.5004 19.0119 16.5004 18.7002V15.4002C16.5004 15.0885 16.395 14.8273 16.1841 14.6164C15.9733 14.4056 15.7121 14.3002 15.4004 14.3002H12.1004V13.2002H15.4004C15.7121 13.2002 15.9733 13.0948 16.1841 12.8839C16.395 12.6731 16.5004 12.4119 16.5004 12.1002C16.5004 11.7885 16.395 11.5273 16.1841 11.3164C15.9733 11.1056 15.7121 11.0002 15.4004 11.0002H14.3004V10.4502C14.3004 10.3035 14.2454 10.1752 14.1354 10.0652C14.0254 9.9552 13.8971 9.9002 13.7504 9.9002H12.6504C12.5037 9.9002 12.3754 9.9552 12.2654 10.0652C12.1554 10.1752 12.1004 10.3035 12.1004 10.4502V11.0002H11.0004C10.6887 11.0002 10.4275 11.1056 10.2166 11.3164C10.0058 11.5273 9.90039 11.7885 9.90039 12.1002V15.4002C9.90039 15.7119 10.0058 15.9731 10.2166 16.1839C10.4275 16.3948 10.6887 16.5002 11.0004 16.5002H14.3004V17.6002H11.0004C10.6887 17.6002 10.4275 17.7056 10.2166 17.9164C10.0058 18.1273 9.90039 18.3885 9.90039 18.7002C9.90039 19.0119 10.0058 19.2731 10.2166 19.4839C10.4275 19.6948 10.6887 19.8002 11.0004 19.8002H12.1004ZM6.60039 24.2002C5.99539 24.2002 5.47747 23.9848 5.04664 23.5539C4.61581 23.1231 4.40039 22.6052 4.40039 22.0002V4.4002C4.40039 3.7952 4.61581 3.27728 5.04664 2.84645C5.47747 2.41561 5.99539 2.2002 6.60039 2.2002H16.5004L22.0004 7.7002V22.0002C22.0004 22.6052 21.785 23.1231 21.3541 23.5539C20.9233 23.9848 20.4054 24.2002 19.8004 24.2002H6.60039ZM15.4004 4.4002V7.7002C15.4004 8.01186 15.5058 8.27311 15.7166 8.48395C15.9275 8.69478 16.1887 8.8002 16.5004 8.8002H19.8004L15.4004 4.4002Z"
            fill="#42887D"
          />
        </svg>
      </div>
      <div class="estimate-text">
        <h6 class="text-body1 font-bold">Provide Estimate</h6>
        <p class="text-body2">Please provide an estimate</p>
      </div>
    </div>
    <button class="btn btn-primary" (click)="openAddEstimateModal()">
      Add Estimate
    </button>
  </div>
  <!-- Provide Estimate card end -->
  <!-- Customer confirmation start -->
  <!-- *ngIf="orderData?.state?.code === orderStateCode['inProcess']" -->
  <div
    *ngIf="orderData?.state?.code === orderStateCode['estimated']"
    class="estimate-card customer-confirmation mb-3 p-3"
  >
    <div class="estimate-info">
      <div class="estimate-icon">
        <svg
          width="27"
          height="27"
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.2004 13.2004C11.9904 13.2004 10.9546 12.7696 10.0929 11.9079C9.23122 11.0462 8.80039 10.0104 8.80039 8.80039C8.80039 7.59039 9.23122 6.55456 10.0929 5.69289C10.9546 4.83122 11.9904 4.40039 13.2004 4.40039C14.4104 4.40039 15.4462 4.83122 16.3079 5.69289C17.1696 6.55456 17.6004 7.59039 17.6004 8.80039C17.6004 10.0104 17.1696 11.0462 16.3079 11.9079C15.4462 12.7696 14.4104 13.2004 13.2004 13.2004ZM4.40039 19.8004V18.9204C4.40039 18.2971 4.56081 17.7241 4.88164 17.2016C5.20247 16.6791 5.62872 16.2804 6.16039 16.0054C7.29706 15.4371 8.45206 15.0108 9.62539 14.7266C10.7987 14.4425 11.9904 14.3004 13.2004 14.3004C14.4104 14.3004 15.6021 14.4425 16.7754 14.7266C17.9487 15.0108 19.1037 15.4371 20.2404 16.0054C20.7721 16.2804 21.1983 16.6791 21.5191 17.2016C21.84 17.7241 22.0004 18.2971 22.0004 18.9204V19.8004C22.0004 20.4054 21.785 20.9233 21.3541 21.3541C20.9233 21.785 20.4054 22.0004 19.8004 22.0004H6.60039C5.99539 22.0004 5.47747 21.785 5.04664 21.3541C4.61581 20.9233 4.40039 20.4054 4.40039 19.8004Z"
            fill="#8E44AD"
          />
        </svg>
      </div>
      <div class="estimate-text">
        <h6 class="text-body1 font-bold">Confirmation Pending</h6>
        <p class="text-body2">Please waiting for customer confirmation</p>
      </div>
    </div>
  </div>
  <!-- Customer confirmation end -->
  <!-- Invoice Generate start -->
  <bst-frontend-invoice
    *ngIf="orderData?.state?.code === orderStateCode['Delivered']"
    [orderData]="orderData"
  ></bst-frontend-invoice>
  <!-- Invoice Generate end -->
  <!-- Invoice Generate start -->

  <div
    class="estimate-card mb-3 p-3"
    *ngIf="orderData?.state?.code === orderStateCode['Invoice-Uploaded']"
  >
    <div class="estimate-info">
      <div class="estimate-icon">
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.7812 25.875L9.09375 17.875C8.98958 17.7708 8.90625 17.6406 8.84375 17.4844C8.78125 17.3281 8.75 17.1667 8.75 17V16.25C8.75 15.8958 8.86979 15.599 9.10938 15.3594C9.34896 15.1198 9.64583 15 10 15H13.125C14.2292 15 15.1823 14.6406 15.9844 13.9219C16.7865 13.2031 17.2708 12.3125 17.4375 11.25H8.75C8.39583 11.25 8.09896 11.1302 7.85938 10.8906C7.61979 10.651 7.5 10.3542 7.5 10C7.5 9.64583 7.61979 9.34896 7.85938 9.10938C8.09896 8.86979 8.39583 8.75 8.75 8.75H17.0625C16.7083 8.02083 16.1823 7.42188 15.4844 6.95312C14.7865 6.48438 14 6.25 13.125 6.25H8.75C8.39583 6.25 8.09896 6.13021 7.85938 5.89062C7.61979 5.65104 7.5 5.35417 7.5 5C7.5 4.64583 7.61979 4.34896 7.85938 4.10938C8.09896 3.86979 8.39583 3.75 8.75 3.75H21.25C21.6042 3.75 21.901 3.86979 22.1406 4.10938C22.3802 4.34896 22.5 4.64583 22.5 5C22.5 5.35417 22.3802 5.65104 22.1406 5.89062C21.901 6.13021 21.6042 6.25 21.25 6.25H18.4375C18.7292 6.60417 18.9896 6.98958 19.2188 7.40625C19.4479 7.82292 19.625 8.27083 19.75 8.75H21.25C21.6042 8.75 21.901 8.86979 22.1406 9.10938C22.3802 9.34896 22.5 9.64583 22.5 10C22.5 10.3542 22.3802 10.651 22.1406 10.8906C21.901 11.1302 21.6042 11.25 21.25 11.25H19.9688C19.8021 13.0208 19.0729 14.5052 17.7812 15.7031C16.4896 16.901 14.9375 17.5 13.125 17.5H12.2188L18.5938 24.125C18.9688 24.5208 19.0469 24.974 18.8281 25.4844C18.6094 25.9948 18.2292 26.25 17.6875 26.25C17.5208 26.25 17.3594 26.2188 17.2031 26.1562C17.0469 26.0938 16.9062 26 16.7812 25.875Z"
            fill="#F79009"
          />
        </svg>
      </div>
      <div class="estimate-text">
        <h6 class="text-body1 font-bold">Order Paid</h6>
        <p class="text-body2">Please confirm payment and make it paid</p>
      </div>
    </div>
    <button
      class="btn btn-primary"
      *ngIf="orderData?.state?.code === orderStateCode['Invoice-Uploaded']"
      (click)="openConfirmPaymentModal()"
    >
      Order Paid
    </button>
  </div>
  <!-- Invoice Generate end -->
  <ng-container *ngIf="orderData?.sharedDelivery">
    <div class="sub-order-card rounded-xl mb-4">
      <!-- Header -->
      <div
        class="location-header p-3 d-flex align-items-center justify-content-between"
      >
        <div class="location-header-left d-flex align-items-center gap-2">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="#FEE4E2"></circle>
            <path
              d="M11.9987 11.6663C11.5567 11.6663 11.1327 11.4907 10.8202 11.1782C10.5076 10.8656 10.332 10.4417 10.332 9.99967C10.332 9.55765 10.5076 9.13372 10.8202 8.82116C11.1327 8.5086 11.5567 8.33301 11.9987 8.33301C12.4407 8.33301 12.8646 8.5086 13.1772 8.82116C13.4898 9.13372 13.6654 9.55765 13.6654 9.99967C13.6654 10.2185 13.6223 10.4353 13.5385 10.6375C13.4547 10.8397 13.332 11.0234 13.1772 11.1782C13.0224 11.3329 12.8387 11.4557 12.6365 11.5395C12.4343 11.6232 12.2176 11.6663 11.9987 11.6663ZM11.9987 5.33301C10.761 5.33301 9.57404 5.82467 8.69887 6.69984C7.8237 7.57501 7.33203 8.762 7.33203 9.99967C7.33203 13.4997 11.9987 18.6663 11.9987 18.6663C11.9987 18.6663 16.6654 13.4997 16.6654 9.99967C16.6654 8.762 16.1737 7.57501 15.2985 6.69984C14.4234 5.82467 13.2364 5.33301 11.9987 5.33301Z"
              fill="#F04438"
            ></path>
          </svg>
          <p class="text-body1 font-bold">
            {{ orderData.sharedDelivery.address.companyName }}
          </p>
        </div>
      </div>

      <!-- Table -->
      <div class="table-wrapper">
        <table class="delivery-table">
          <thead>
            <tr>
              <th>Godown (Label)</th>
              <th>Product & Size</th>
              <th>Weight (KG)</th>
              <th>Qty (Box)</th>
              <th>Delivery Name & Number</th>
            </tr>
          </thead>

          <tbody>
            <ng-container *ngFor="let item of allPickupItems; let i = index">
              <tr>
                <!-- Godown -->
                <td
                  *ngIf="i === 0"
                  [attr.rowspan]="allPickupItems.length"
                  class="godown-cell"
                >
                  <p class="text-body2 font-bold">
                    {{ orderData.sharedDelivery.address.companyName }}
                  </p>
                  <p class="text-body2">
                    {{ orderData.sharedDelivery.address.locality }},
                    {{ orderData.sharedDelivery.address.city }}
                  </p>
                </td>

                <!-- Product & Size -->
                <td>
                  <strong>{{ item.product.name }}</strong>
                  <span *ngIf="item.product.subItems">
                    {{ item.product.subItems.name }}
                  </span>
                </td>

                <!-- Weight -->
                <td>{{ item.planned.showWeight }}</td>

                <!-- Qty -->
                <td>{{ item.planned.qty }}</td>

                <!-- Delivery Contact -->
                <td
                  *ngIf="i === 0"
                  [attr.rowspan]="allPickupItems.length"
                  class="delivery-contact"
                >
                  <p class="text-body2 font-bold">
                    {{ orderData.sharedDelivery.address.contactName }}
                  </p>
                  <a
                    class="btn-link btn-link-primary"
                    href="tel:{{
                      orderData.sharedDelivery.address.contactNumber
                    }}"
                  >
                    {{ orderData.sharedDelivery.address.contactNumber }}
                  </a>
                </td>
              </tr>
            </ng-container>

            <!-- Total Row -->
            <tr class="total-row">
              <td></td>
              <td><strong>Total</strong></td>
              <td>
                <strong>{{ partLoadtotalWeight }}</strong>
              </td>
              <td>
                <strong>{{ partLoadtotalQty }}</strong>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>

  <ng-container *ngFor="let item of orderData.subOrders; let i = index">
    <h4 class="order-lr-number font-bold mb-2">
      {{
        item?.truckAssignment?.lrNumber
          ? item?.truckAssignment?.lrNumber
          : 'Pickup & Delivery'
      }}
    </h4>
    <div class="sub-order-card rounded-xl mb-4">
      <!-- sub order status start here -->
      <!-- *ngIf="orderData?.state?.code === orderStateCode['estimated']" -->
      <div
        *ngIf="showOrderState.includes(orderData?.state?.code)"
        class="progress-tracker current-step-truck-assign p-3 d-flex justify-content-between align-item-start"
        [attr.data-step]="item?.statusNumber"
      >
        <div class="progress-line"></div>
        <div class="progress-fill"></div>
        <!-- Animated Truck Icon -->
        <div *ngIf="item?.statusNumber < 7" class="truck-animation">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.99967 16.6663C4.30523 16.6663 3.71495 16.4233 3.22884 15.9372C2.74273 15.4511 2.49967 14.8608 2.49967 14.1663H1.66634C1.43023 14.1663 1.23231 14.0865 1.07259 13.9268C0.912869 13.767 0.833008 13.5691 0.833008 13.333V4.99967C0.833008 4.54134 0.996202 4.14898 1.32259 3.82259C1.64898 3.4962 2.04134 3.33301 2.49967 3.33301H12.4997C12.958 3.33301 13.3504 3.4962 13.6768 3.82259C14.0031 4.14898 14.1663 4.54134 14.1663 4.99967V6.66634H15.833C16.0969 6.66634 16.3469 6.72537 16.583 6.84342C16.8191 6.96148 17.0136 7.12467 17.1663 7.33301L18.9997 9.77051C19.0552 9.83995 19.0969 9.91634 19.1247 9.99967C19.1525 10.083 19.1663 10.1733 19.1663 10.2705V13.333C19.1663 13.5691 19.0865 13.767 18.9268 13.9268C18.767 14.0865 18.5691 14.1663 18.333 14.1663H17.4997C17.4997 14.8608 17.2566 15.4511 16.7705 15.9372C16.2844 16.4233 15.6941 16.6663 14.9997 16.6663C14.3052 16.6663 13.715 16.4233 13.2288 15.9372C12.7427 15.4511 12.4997 14.8608 12.4997 14.1663H7.49967C7.49967 14.8608 7.25662 15.4511 6.77051 15.9372C6.2844 16.4233 5.69412 16.6663 4.99967 16.6663ZM4.99967 14.9997C5.23579 14.9997 5.4337 14.9198 5.59342 14.7601C5.75315 14.6004 5.83301 14.4025 5.83301 14.1663C5.83301 13.9302 5.75315 13.7323 5.59342 13.5726C5.4337 13.4129 5.23579 13.333 4.99967 13.333C4.76356 13.333 4.56565 13.4129 4.40592 13.5726C4.2462 13.7323 4.16634 13.9302 4.16634 14.1663C4.16634 14.4025 4.2462 14.6004 4.40592 14.7601C4.56565 14.9198 4.76356 14.9997 4.99967 14.9997ZM14.9997 14.9997C15.2358 14.9997 15.4337 14.9198 15.5934 14.7601C15.7531 14.6004 15.833 14.4025 15.833 14.1663C15.833 13.9302 15.7531 13.7323 15.5934 13.5726C15.4337 13.4129 15.2358 13.333 14.9997 13.333C14.7636 13.333 14.5656 13.4129 14.4059 13.5726C14.2462 13.7323 14.1663 13.9302 14.1663 14.1663C14.1663 14.4025 14.2462 14.6004 14.4059 14.7601C14.5656 14.9198 14.7636 14.9997 14.9997 14.9997ZM14.1663 10.833H17.708L15.833 8.33301H14.1663V10.833Z"
              fill="#004B64"
            />
          </svg>
        </div>
        <!-- Truck Assign status start -->
        <div
          class="progress-step"
          [ngClass]="{
            'current-step': item?.statusNumber === 1,
            'complete-step': item?.statusNumber !== 1
          }"
        >
          <div class="step-circle mb-2">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.06634 9.19968L5.63301 7.76634C5.51079 7.64412 5.35523 7.58301 5.16634 7.58301C4.97745 7.58301 4.8219 7.64412 4.69967 7.76634C4.57745 7.88856 4.51634 8.04412 4.51634 8.23301C4.51634 8.4219 4.57745 8.57745 4.69967 8.69968L6.59967 10.5997C6.73301 10.733 6.88856 10.7997 7.06634 10.7997C7.24412 10.7997 7.39968 10.733 7.53301 10.5997L11.2997 6.83301C11.4219 6.71079 11.483 6.55523 11.483 6.36634C11.483 6.17745 11.4219 6.0219 11.2997 5.89967C11.1775 5.77745 11.0219 5.71634 10.833 5.71634C10.6441 5.71634 10.4886 5.77745 10.3663 5.89967L7.06634 9.19968ZM7.99967 14.6663C7.07745 14.6663 6.21079 14.4913 5.39967 14.1413C4.58856 13.7913 3.88301 13.3163 3.28301 12.7163C2.68301 12.1163 2.20801 11.4108 1.85801 10.5997C1.50801 9.78856 1.33301 8.9219 1.33301 7.99967C1.33301 7.07745 1.50801 6.21079 1.85801 5.39967C2.20801 4.58856 2.68301 3.88301 3.28301 3.28301C3.88301 2.68301 4.58856 2.20801 5.39967 1.85801C6.21079 1.50801 7.07745 1.33301 7.99967 1.33301C8.9219 1.33301 9.78856 1.50801 10.5997 1.85801C11.4108 2.20801 12.1163 2.68301 12.7163 3.28301C13.3163 3.88301 13.7913 4.58856 14.1413 5.39967C14.4913 6.21079 14.6663 7.07745 14.6663 7.99967C14.6663 8.9219 14.4913 9.78856 14.1413 10.5997C13.7913 11.4108 13.3163 12.1163 12.7163 12.7163C12.1163 13.3163 11.4108 13.7913 10.5997 14.1413C9.78856 14.4913 8.9219 14.6663 7.99967 14.6663Z"
                fill="white"
              />
            </svg>
            <span class="dot"></span>
          </div>
          <p class="step-title text-subtitle2 font-bold">Truck assigned</p>
          <!-- <p *ngIf="item?.statusNumber === 1" class="step-subtitle">
            Please assign truck
          </p> -->
          <ng-container *ngIf="item?.statusNumber > 1">
            <p class="step-subtitle">
              {{
                item?.truckAssignment?.assignedAt | date : 'HH:mm ddMMM yyyy'
              }}
            </p>
            <p class="step-title text-body2 font-bold">
              Truck: {{ item?.truckAssignment?.truckNo }}
            </p>
          </ng-container>

          <div class="d-flex align-item-start justify-content-between gap-1">
            <button
              *ngIf="item?.statusNumber === 1"
              class="btn btn-primary mt-2"
              (click)="openAssignTruckModal('create', item)"
            >
              Assign Truck
            </button>
            <button
              *ngIf="item?.statusNumber > 1"
              (click)="openAssignTruckModal('edit', item)"
              class="btn btn-light d-flex align-items-center justify-content-center gap-1 mt-2"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 14V11.1667L10.8 2.38333C10.9333 2.26111 11.0806 2.16667 11.2417 2.1C11.4028 2.03333 11.5722 2 11.75 2C11.9278 2 12.1 2.03333 12.2667 2.1C12.4333 2.16667 12.5778 2.26667 12.7 2.4L13.6167 3.33333C13.75 3.45556 13.8472 3.6 13.9083 3.76667C13.9694 3.93333 14 4.1 14 4.26667C14 4.44444 13.9694 4.61389 13.9083 4.775C13.8472 4.93611 13.75 5.08333 13.6167 5.21667L4.83333 14H2ZM11.7333 5.2L12.6667 4.26667L11.7333 3.33333L10.8 4.26667L11.7333 5.2Z"
                  fill="#004B64"
                />
              </svg>
            </button>
            <button
              *ngIf="item?.statusNumber > 1"
              (click)="openAssignTruckModal('view', item)"
              class="btn btn-light d-flex align-items-center justify-content-center gap-1 mt-3"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.99961 10.667C8.83294 10.667 9.54128 10.3753 10.1246 9.79199C10.7079 9.20866 10.9996 8.50033 10.9996 7.66699C10.9996 6.83366 10.7079 6.12533 10.1246 5.54199C9.54128 4.95866 8.83294 4.66699 7.99961 4.66699C7.16628 4.66699 6.45794 4.95866 5.87461 5.54199C5.29128 6.12533 4.99961 6.83366 4.99961 7.66699C4.99961 8.50033 5.29128 9.20866 5.87461 9.79199C6.45794 10.3753 7.16628 10.667 7.99961 10.667ZM7.99961 9.46699C7.49961 9.46699 7.07461 9.29199 6.72461 8.94199C6.37461 8.59199 6.19961 8.16699 6.19961 7.66699C6.19961 7.16699 6.37461 6.74199 6.72461 6.39199C7.07461 6.04199 7.49961 5.86699 7.99961 5.86699C8.49961 5.86699 8.92461 6.04199 9.27461 6.39199C9.62461 6.74199 9.79961 7.16699 9.79961 7.66699C9.79961 8.16699 9.62461 8.59199 9.27461 8.94199C8.92461 9.29199 8.49961 9.46699 7.99961 9.46699ZM7.99961 12.667C6.51072 12.667 5.15239 12.267 3.92461 11.467C2.69683 10.667 1.72739 9.61144 1.01628 8.30033C0.96072 8.20033 0.919054 8.09755 0.891276 7.99199C0.863498 7.88644 0.849609 7.7781 0.849609 7.66699C0.849609 7.55588 0.863498 7.44755 0.891276 7.34199C0.919054 7.23644 0.96072 7.13366 1.01628 7.03366C1.72739 5.72255 2.69683 4.66699 3.92461 3.86699C5.15239 3.06699 6.51072 2.66699 7.99961 2.66699C9.4885 2.66699 10.8468 3.06699 12.0746 3.86699C13.3024 4.66699 14.2718 5.72255 14.9829 7.03366C15.0385 7.13366 15.0802 7.23644 15.1079 7.34199C15.1357 7.44755 15.1496 7.55588 15.1496 7.66699C15.1496 7.7781 15.1357 7.88644 15.1079 7.99199C15.0802 8.09755 15.0385 8.20033 14.9829 8.30033C14.2718 9.61144 13.3024 10.667 12.0746 11.467C10.8468 12.267 9.4885 12.667 7.99961 12.667Z"
                  fill="#004B64"
                />
              </svg>
            </button>
            <button
              *ngIf="item?.statusNumber > 1"
              (click)="openAssignDriverModal('create', item)"
              class="btn btn-light d-flex align-items-center justify-content-center gap-1 mt-2"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 14V11.1667L10.8 2.38333C10.9333 2.26111 11.0806 2.16667 11.2417 2.1C11.4028 2.03333 11.5722 2 11.75 2C11.9278 2 12.1 2.03333 12.2667 2.1C12.4333 2.16667 12.5778 2.26667 12.7 2.4L13.6167 3.33333C13.75 3.45556 13.8472 3.6 13.9083 3.76667C13.9694 3.93333 14 4.1 14 4.26667C14 4.44444 13.9694 4.61389 13.9083 4.775C13.8472 4.93611 13.75 5.08333 13.6167 5.21667L4.83333 14H2ZM11.7333 5.2L12.6667 4.26667L11.7333 3.33333L10.8 4.26667L11.7333 5.2Z"
                  fill="#004B64"
                />
              </svg>
              Driver
            </button>
          </div>
        </div>
        <!-- Truck Assign status end -->
        <!-- Vehicle there status start -->
        <div
          class="progress-step"
          [ngClass]="{
            'current-step': item?.statusNumber === 2,
            'complete-step': item?.statusNumber > 2
          }"
        >
          <div class="step-circle mb-2">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.06634 9.19968L5.63301 7.76634C5.51079 7.64412 5.35523 7.58301 5.16634 7.58301C4.97745 7.58301 4.8219 7.64412 4.69967 7.76634C4.57745 7.88856 4.51634 8.04412 4.51634 8.23301C4.51634 8.4219 4.57745 8.57745 4.69967 8.69968L6.59967 10.5997C6.73301 10.733 6.88856 10.7997 7.06634 10.7997C7.24412 10.7997 7.39968 10.733 7.53301 10.5997L11.2997 6.83301C11.4219 6.71079 11.483 6.55523 11.483 6.36634C11.483 6.17745 11.4219 6.0219 11.2997 5.89967C11.1775 5.77745 11.0219 5.71634 10.833 5.71634C10.6441 5.71634 10.4886 5.77745 10.3663 5.89967L7.06634 9.19968ZM7.99967 14.6663C7.07745 14.6663 6.21079 14.4913 5.39967 14.1413C4.58856 13.7913 3.88301 13.3163 3.28301 12.7163C2.68301 12.1163 2.20801 11.4108 1.85801 10.5997C1.50801 9.78856 1.33301 8.9219 1.33301 7.99967C1.33301 7.07745 1.50801 6.21079 1.85801 5.39967C2.20801 4.58856 2.68301 3.88301 3.28301 3.28301C3.88301 2.68301 4.58856 2.20801 5.39967 1.85801C6.21079 1.50801 7.07745 1.33301 7.99967 1.33301C8.9219 1.33301 9.78856 1.50801 10.5997 1.85801C11.4108 2.20801 12.1163 2.68301 12.7163 3.28301C13.3163 3.88301 13.7913 4.58856 14.1413 5.39967C14.4913 6.21079 14.6663 7.07745 14.6663 7.99967C14.6663 8.9219 14.4913 9.78856 14.1413 10.5997C13.7913 11.4108 13.3163 12.1163 12.7163 12.7163C12.1163 13.3163 11.4108 13.7913 10.5997 14.1413C9.78856 14.4913 8.9219 14.6663 7.99967 14.6663Z"
                fill="white"
              />
            </svg>
            <span class="dot"></span>
          </div>
          <p class="step-title text-body1 font-bold">Vehicle arrived</p>
          <!-- <p *ngIf="item?.statusNumber <= 2" class="step-subtitle">
            Please there vehicle
          </p> -->
          <ng-container *ngIf="item?.statusNumber > 2">
            <p class="step-subtitle">
              {{
                getStatusDate(item?.historyCompact, 3)
                  | date : 'HH:mm ddMMM yyyy'
              }}
            </p>
            <p class="step-title text-body2 font-bold">
              Tempo: {{ item?.truckAssignment?.tempoNo }}
            </p>
          </ng-container>
          <button
            *ngIf="item?.statusNumber === 2"
            class="btn btn-primary mt-2"
            (click)="vehicleThereModal(item)"
          >
            Vehicle there
          </button>
        </div>
        <!-- Vehicle there status end -->
        <!-- Ready to Dispatch status start -->
        <div
          class="progress-step"
          [ngClass]="{
            'current-step': item?.statusNumber === 3,
            'complete-step': item?.statusNumber > 3
          }"
        >
          <div class="step-circle mb-2">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.06634 9.19968L5.63301 7.76634C5.51079 7.64412 5.35523 7.58301 5.16634 7.58301C4.97745 7.58301 4.8219 7.64412 4.69967 7.76634C4.57745 7.88856 4.51634 8.04412 4.51634 8.23301C4.51634 8.4219 4.57745 8.57745 4.69967 8.69968L6.59967 10.5997C6.73301 10.733 6.88856 10.7997 7.06634 10.7997C7.24412 10.7997 7.39968 10.733 7.53301 10.5997L11.2997 6.83301C11.4219 6.71079 11.483 6.55523 11.483 6.36634C11.483 6.17745 11.4219 6.0219 11.2997 5.89967C11.1775 5.77745 11.0219 5.71634 10.833 5.71634C10.6441 5.71634 10.4886 5.77745 10.3663 5.89967L7.06634 9.19968ZM7.99967 14.6663C7.07745 14.6663 6.21079 14.4913 5.39967 14.1413C4.58856 13.7913 3.88301 13.3163 3.28301 12.7163C2.68301 12.1163 2.20801 11.4108 1.85801 10.5997C1.50801 9.78856 1.33301 8.9219 1.33301 7.99967C1.33301 7.07745 1.50801 6.21079 1.85801 5.39967C2.20801 4.58856 2.68301 3.88301 3.28301 3.28301C3.88301 2.68301 4.58856 2.20801 5.39967 1.85801C6.21079 1.50801 7.07745 1.33301 7.99967 1.33301C8.9219 1.33301 9.78856 1.50801 10.5997 1.85801C11.4108 2.20801 12.1163 2.68301 12.7163 3.28301C13.3163 3.88301 13.7913 4.58856 14.1413 5.39967C14.4913 6.21079 14.6663 7.07745 14.6663 7.99967C14.6663 8.9219 14.4913 9.78856 14.1413 10.5997C13.7913 11.4108 13.3163 12.1163 12.7163 12.7163C12.1163 13.3163 11.4108 13.7913 10.5997 14.1413C9.78856 14.4913 8.9219 14.6663 7.99967 14.6663Z"
                fill="white"
              />
            </svg>
            <span class="dot"></span>
          </div>
          <p class="step-title text-body1 font-bold">Ready for dispatch</p>
          <!-- <p *ngIf="item?.statusNumber <= 3" class="step-subtitle">
            Please ready to dispatch
          </p> -->
          <ng-container *ngIf="item?.statusNumber > 3">
            <p class="step-subtitle">
              {{
                getStatusDate(item?.historyCompact, 4)
                  | date : 'HH:mm ddMMM yyyy'
              }}
            </p>
            <p class="step-title text-body2 font-bold">
              Truck: {{ item?.truckAssignment?.truckNo }}
            </p>
          </ng-container>
          <button
            *ngIf="item?.statusNumber === 3"
            class="btn btn-primary mt-2"
            (click)="openReadyToDispatchModal(item)"
          >
            Ready to Dispatch
          </button>
          <button
            *ngIf="item?.statusNumber > 3"
            (click)="openReadyToDispatchModal(item, 'edit')"
            class="btn btn-light d-flex align-items-center justify-content-center gap-1 mt-2"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 14V11.1667L10.8 2.38333C10.9333 2.26111 11.0806 2.16667 11.2417 2.1C11.4028 2.03333 11.5722 2 11.75 2C11.9278 2 12.1 2.03333 12.2667 2.1C12.4333 2.16667 12.5778 2.26667 12.7 2.4L13.6167 3.33333C13.75 3.45556 13.8472 3.6 13.9083 3.76667C13.9694 3.93333 14 4.1 14 4.26667C14 4.44444 13.9694 4.61389 13.9083 4.775C13.8472 4.93611 13.75 5.08333 13.6167 5.21667L4.83333 14H2ZM11.7333 5.2L12.6667 4.26667L11.7333 3.33333L10.8 4.26667L11.7333 5.2Z"
                fill="#004B64"
              />
            </svg>
          </button>
          <button
            *ngIf="item?.statusNumber > 3"
            (click)="openReadyToDispatchModal(item, 'view')"
            class="btn btn-light d-flex align-items-center justify-content-center gap-1 mt-3"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.99961 10.667C8.83294 10.667 9.54128 10.3753 10.1246 9.79199C10.7079 9.20866 10.9996 8.50033 10.9996 7.66699C10.9996 6.83366 10.7079 6.12533 10.1246 5.54199C9.54128 4.95866 8.83294 4.66699 7.99961 4.66699C7.16628 4.66699 6.45794 4.95866 5.87461 5.54199C5.29128 6.12533 4.99961 6.83366 4.99961 7.66699C4.99961 8.50033 5.29128 9.20866 5.87461 9.79199C6.45794 10.3753 7.16628 10.667 7.99961 10.667ZM7.99961 9.46699C7.49961 9.46699 7.07461 9.29199 6.72461 8.94199C6.37461 8.59199 6.19961 8.16699 6.19961 7.66699C6.19961 7.16699 6.37461 6.74199 6.72461 6.39199C7.07461 6.04199 7.49961 5.86699 7.99961 5.86699C8.49961 5.86699 8.92461 6.04199 9.27461 6.39199C9.62461 6.74199 9.79961 7.16699 9.79961 7.66699C9.79961 8.16699 9.62461 8.59199 9.27461 8.94199C8.92461 9.29199 8.49961 9.46699 7.99961 9.46699ZM7.99961 12.667C6.51072 12.667 5.15239 12.267 3.92461 11.467C2.69683 10.667 1.72739 9.61144 1.01628 8.30033C0.96072 8.20033 0.919054 8.09755 0.891276 7.99199C0.863498 7.88644 0.849609 7.7781 0.849609 7.66699C0.849609 7.55588 0.863498 7.44755 0.891276 7.34199C0.919054 7.23644 0.96072 7.13366 1.01628 7.03366C1.72739 5.72255 2.69683 4.66699 3.92461 3.86699C5.15239 3.06699 6.51072 2.66699 7.99961 2.66699C9.4885 2.66699 10.8468 3.06699 12.0746 3.86699C13.3024 4.66699 14.2718 5.72255 14.9829 7.03366C15.0385 7.13366 15.0802 7.23644 15.1079 7.34199C15.1357 7.44755 15.1496 7.55588 15.1496 7.66699C15.1496 7.7781 15.1357 7.88644 15.1079 7.99199C15.0802 8.09755 15.0385 8.20033 14.9829 8.30033C14.2718 9.61144 13.3024 10.667 12.0746 11.467C10.8468 12.267 9.4885 12.667 7.99961 12.667Z"
                fill="#004B64"
              />
            </svg>
          </button>
        </div>
        <!-- Ready to Dispatch status end -->
        <!-- In transit status start -->
        <div
          class="progress-step"
          [ngClass]="{
            'current-step': item?.statusNumber === 4,
            'complete-step': item?.statusNumber > 4
          }"
        >
          <div class="step-circle mb-2">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.06634 9.19968L5.63301 7.76634C5.51079 7.64412 5.35523 7.58301 5.16634 7.58301C4.97745 7.58301 4.8219 7.64412 4.69967 7.76634C4.57745 7.88856 4.51634 8.04412 4.51634 8.23301C4.51634 8.4219 4.57745 8.57745 4.69967 8.69968L6.59967 10.5997C6.73301 10.733 6.88856 10.7997 7.06634 10.7997C7.24412 10.7997 7.39968 10.733 7.53301 10.5997L11.2997 6.83301C11.4219 6.71079 11.483 6.55523 11.483 6.36634C11.483 6.17745 11.4219 6.0219 11.2997 5.89967C11.1775 5.77745 11.0219 5.71634 10.833 5.71634C10.6441 5.71634 10.4886 5.77745 10.3663 5.89967L7.06634 9.19968ZM7.99967 14.6663C7.07745 14.6663 6.21079 14.4913 5.39967 14.1413C4.58856 13.7913 3.88301 13.3163 3.28301 12.7163C2.68301 12.1163 2.20801 11.4108 1.85801 10.5997C1.50801 9.78856 1.33301 8.9219 1.33301 7.99967C1.33301 7.07745 1.50801 6.21079 1.85801 5.39967C2.20801 4.58856 2.68301 3.88301 3.28301 3.28301C3.88301 2.68301 4.58856 2.20801 5.39967 1.85801C6.21079 1.50801 7.07745 1.33301 7.99967 1.33301C8.9219 1.33301 9.78856 1.50801 10.5997 1.85801C11.4108 2.20801 12.1163 2.68301 12.7163 3.28301C13.3163 3.88301 13.7913 4.58856 14.1413 5.39967C14.4913 6.21079 14.6663 7.07745 14.6663 7.99967C14.6663 8.9219 14.4913 9.78856 14.1413 10.5997C13.7913 11.4108 13.3163 12.1163 12.7163 12.7163C12.1163 13.3163 11.4108 13.7913 10.5997 14.1413C9.78856 14.4913 8.9219 14.6663 7.99967 14.6663Z"
                fill="white"
              />
            </svg>
            <span class="dot"></span>
          </div>
          <p class="step-title text-body1 font-bold">In transit</p>
          <!-- <p class="step-subtitle" *ngIf="item?.statusNumber <= 4">
            Please ready to In transit
          </p> -->
          <ng-container *ngIf="item?.statusNumber > 4">
            <p class="step-subtitle">
              {{
                getStatusDate(item?.historyCompact, 5)
                  | date : 'HH:mm ddMMM yyyy'
              }}
            </p>
            <p class="step-title text-body2 font-bold">
              Truck: {{ item?.truckAssignment?.truckNo }}
            </p>
          </ng-container>
          <div
            class="d-flex align-item-start justify-content-between gap-1 mt-2"
          >
            <a
              *ngIf="item?.statusNumber === 4"
              [routerLink]="[
                '/order/truck-detail',
                item?.truckAssignment?.truckOrderId
              ]"
              class="btn btn-primary flex-nowrap"
            >
              In Transit
            </a>
          </div>
        </div>
        <!-- In transit status end -->
        <!-- Truck reached status start -->
        <div
          class="progress-step"
          [ngClass]="{
            'current-step': item?.statusNumber === 5,
            'complete-step': item?.statusNumber > 5
          }"
        >
          <div class="step-circle mb-2">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.06634 9.19968L5.63301 7.76634C5.51079 7.64412 5.35523 7.58301 5.16634 7.58301C4.97745 7.58301 4.8219 7.64412 4.69967 7.76634C4.57745 7.88856 4.51634 8.04412 4.51634 8.23301C4.51634 8.4219 4.57745 8.57745 4.69967 8.69968L6.59967 10.5997C6.73301 10.733 6.88856 10.7997 7.06634 10.7997C7.24412 10.7997 7.39968 10.733 7.53301 10.5997L11.2997 6.83301C11.4219 6.71079 11.483 6.55523 11.483 6.36634C11.483 6.17745 11.4219 6.0219 11.2997 5.89967C11.1775 5.77745 11.0219 5.71634 10.833 5.71634C10.6441 5.71634 10.4886 5.77745 10.3663 5.89967L7.06634 9.19968ZM7.99967 14.6663C7.07745 14.6663 6.21079 14.4913 5.39967 14.1413C4.58856 13.7913 3.88301 13.3163 3.28301 12.7163C2.68301 12.1163 2.20801 11.4108 1.85801 10.5997C1.50801 9.78856 1.33301 8.9219 1.33301 7.99967C1.33301 7.07745 1.50801 6.21079 1.85801 5.39967C2.20801 4.58856 2.68301 3.88301 3.28301 3.28301C3.88301 2.68301 4.58856 2.20801 5.39967 1.85801C6.21079 1.50801 7.07745 1.33301 7.99967 1.33301C8.9219 1.33301 9.78856 1.50801 10.5997 1.85801C11.4108 2.20801 12.1163 2.68301 12.7163 3.28301C13.3163 3.88301 13.7913 4.58856 14.1413 5.39967C14.4913 6.21079 14.6663 7.07745 14.6663 7.99967C14.6663 8.9219 14.4913 9.78856 14.1413 10.5997C13.7913 11.4108 13.3163 12.1163 12.7163 12.7163C12.1163 13.3163 11.4108 13.7913 10.5997 14.1413C9.78856 14.4913 8.9219 14.6663 7.99967 14.6663Z"
                fill="white"
              />
            </svg>
            <span class="dot"></span>
          </div>
          <p class="step-title text-body1 font-bold">
            Truck arrived at destination
          </p>
          <!-- <p *ngIf="item?.statusNumber <= 5" class="step-subtitle">
            Please Truck reached
          </p> -->
          <ng-container *ngIf="item?.statusNumber > 5">
            <p class="step-subtitle">
              {{
                getStatusDate(item?.historyCompact, 6)
                  | date : 'HH:mm ddMMM yyyy'
              }}
            </p>
            <p class="step-title text-body2 font-bold">
              Truck: {{ item?.truckAssignment?.truckNo }}
            </p>
          </ng-container>
          <button
            *ngIf="item?.statusNumber === 5"
            class="btn btn-primary mt-2"
            (click)="truckReachedModal(item)"
          >
            Truck reached
          </button>
        </div>
        <!-- Truck reached status end -->
        <!-- Order  delivered status start -->
        <div
          class="progress-step"
          [ngClass]="{
            'current-step': item?.statusNumber === 6,
            'complete-step': item?.statusNumber > 6
          }"
        >
          <div class="step-circle mb-2">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.06634 9.19968L5.63301 7.76634C5.51079 7.64412 5.35523 7.58301 5.16634 7.58301C4.97745 7.58301 4.8219 7.64412 4.69967 7.76634C4.57745 7.88856 4.51634 8.04412 4.51634 8.23301C4.51634 8.4219 4.57745 8.57745 4.69967 8.69968L6.59967 10.5997C6.73301 10.733 6.88856 10.7997 7.06634 10.7997C7.24412 10.7997 7.39968 10.733 7.53301 10.5997L11.2997 6.83301C11.4219 6.71079 11.483 6.55523 11.483 6.36634C11.483 6.17745 11.4219 6.0219 11.2997 5.89967C11.1775 5.77745 11.0219 5.71634 10.833 5.71634C10.6441 5.71634 10.4886 5.77745 10.3663 5.89967L7.06634 9.19968ZM7.99967 14.6663C7.07745 14.6663 6.21079 14.4913 5.39967 14.1413C4.58856 13.7913 3.88301 13.3163 3.28301 12.7163C2.68301 12.1163 2.20801 11.4108 1.85801 10.5997C1.50801 9.78856 1.33301 8.9219 1.33301 7.99967C1.33301 7.07745 1.50801 6.21079 1.85801 5.39967C2.20801 4.58856 2.68301 3.88301 3.28301 3.28301C3.88301 2.68301 4.58856 2.20801 5.39967 1.85801C6.21079 1.50801 7.07745 1.33301 7.99967 1.33301C8.9219 1.33301 9.78856 1.50801 10.5997 1.85801C11.4108 2.20801 12.1163 2.68301 12.7163 3.28301C13.3163 3.88301 13.7913 4.58856 14.1413 5.39967C14.4913 6.21079 14.6663 7.07745 14.6663 7.99967C14.6663 8.9219 14.4913 9.78856 14.1413 10.5997C13.7913 11.4108 13.3163 12.1163 12.7163 12.7163C12.1163 13.3163 11.4108 13.7913 10.5997 14.1413C9.78856 14.4913 8.9219 14.6663 7.99967 14.6663Z"
                fill="white"
              />
            </svg>
            <span class="dot"></span>
          </div>
          <p class="step-title text-body1 font-bold">Order delivered</p>
          <!-- <p class="step-subtitle" *ngIf="item?.statusNumber <= 6">
            Please deliver order
          </p> -->
          <ng-container *ngIf="item?.statusNumber > 6">
            <p class="step-subtitle">
              {{
                getStatusDate(item?.historyCompact, 7)
                  | date : 'HH:mm ddMMM yyyy'
              }}
            </p>
            <p class="step-title text-body2 font-bold">
              Truck: {{ item?.truckAssignment?.truckNo }}
            </p>
          </ng-container>
          <button
            class="btn btn-primary mt-2"
            *ngIf="item?.statusNumber === 6"
            (click)="openDeliverModal(item, 'edit')"
          >
            Delivered
          </button>
          <button
            *ngIf="item?.statusNumber > 6"
            (click)="openDeliverModal(item, 'edit')"
            class="btn btn-light d-flex align-items-center justify-content-center gap-1 mt-2"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 14V11.1667L10.8 2.38333C10.9333 2.26111 11.0806 2.16667 11.2417 2.1C11.4028 2.03333 11.5722 2 11.75 2C11.9278 2 12.1 2.03333 12.2667 2.1C12.4333 2.16667 12.5778 2.26667 12.7 2.4L13.6167 3.33333C13.75 3.45556 13.8472 3.6 13.9083 3.76667C13.9694 3.93333 14 4.1 14 4.26667C14 4.44444 13.9694 4.61389 13.9083 4.775C13.8472 4.93611 13.75 5.08333 13.6167 5.21667L4.83333 14H2ZM11.7333 5.2L12.6667 4.26667L11.7333 3.33333L10.8 4.26667L11.7333 5.2Z"
                fill="#004B64"
              />
            </svg>
          </button>
          <button
            *ngIf="item?.statusNumber > 6"
            (click)="openDeliverModal(item, 'view')"
            class="btn btn-light d-flex align-items-center justify-content-center gap-1 mt-3"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.99961 10.667C8.83294 10.667 9.54128 10.3753 10.1246 9.79199C10.7079 9.20866 10.9996 8.50033 10.9996 7.66699C10.9996 6.83366 10.7079 6.12533 10.1246 5.54199C9.54128 4.95866 8.83294 4.66699 7.99961 4.66699C7.16628 4.66699 6.45794 4.95866 5.87461 5.54199C5.29128 6.12533 4.99961 6.83366 4.99961 7.66699C4.99961 8.50033 5.29128 9.20866 5.87461 9.79199C6.45794 10.3753 7.16628 10.667 7.99961 10.667ZM7.99961 9.46699C7.49961 9.46699 7.07461 9.29199 6.72461 8.94199C6.37461 8.59199 6.19961 8.16699 6.19961 7.66699C6.19961 7.16699 6.37461 6.74199 6.72461 6.39199C7.07461 6.04199 7.49961 5.86699 7.99961 5.86699C8.49961 5.86699 8.92461 6.04199 9.27461 6.39199C9.62461 6.74199 9.79961 7.16699 9.79961 7.66699C9.79961 8.16699 9.62461 8.59199 9.27461 8.94199C8.92461 9.29199 8.49961 9.46699 7.99961 9.46699ZM7.99961 12.667C6.51072 12.667 5.15239 12.267 3.92461 11.467C2.69683 10.667 1.72739 9.61144 1.01628 8.30033C0.96072 8.20033 0.919054 8.09755 0.891276 7.99199C0.863498 7.88644 0.849609 7.7781 0.849609 7.66699C0.849609 7.55588 0.863498 7.44755 0.891276 7.34199C0.919054 7.23644 0.96072 7.13366 1.01628 7.03366C1.72739 5.72255 2.69683 4.66699 3.92461 3.86699C5.15239 3.06699 6.51072 2.66699 7.99961 2.66699C9.4885 2.66699 10.8468 3.06699 12.0746 3.86699C13.3024 4.66699 14.2718 5.72255 14.9829 7.03366C15.0385 7.13366 15.0802 7.23644 15.1079 7.34199C15.1357 7.44755 15.1496 7.55588 15.1496 7.66699C15.1496 7.7781 15.1357 7.88644 15.1079 7.99199C15.0802 8.09755 15.0385 8.20033 14.9829 8.30033C14.2718 9.61144 13.3024 10.667 12.0746 11.467C10.8468 12.267 9.4885 12.667 7.99961 12.667Z"
                fill="#004B64"
              />
            </svg>
          </button>
        </div>
        <!-- Order delivered status end -->
      </div>
      <!-- sub order status end here -->
      <!-- header start here -->
      <div
        class="location-header p-3 d-flex align-item-center justify-content-between"
      >
        <div class="location-header-left d-flex align-item-center gap-2">
          <div class="location-name d-flex gap-1">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#DCFAE6" />
              <circle cx="12" cy="12" r="6" fill="#47CD89" />
            </svg>
            <p class="text-body1 font-bold">
              {{ item?.pickup?.address?.companyName }}
            </p>
          </div>
          <!-- <div class="header-actions d-flex align-item-center gap-2">
        <button
          class="btn-link btn-link-primary d-flex align-items-center text-body2 gap-1 p-0"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_811_8017)">
              <g filter="url(#filter0_f_811_8017)">
                <path
                  d="M5.6022 14.1963L5.8318 14.332C6.79613 14.9032 7.90181 15.2054 9.02938 15.2059H9.03175C12.4945 15.2059 15.3126 12.3938 15.314 8.93752C15.3146 7.26263 14.6618 5.68761 13.4757 4.50283C12.8939 3.91853 12.2018 3.45521 11.4394 3.13967C10.677 2.82414 9.85953 2.66267 9.03421 2.66461C5.56881 2.66461 2.75061 5.47639 2.74937 8.93249C2.74767 10.1127 3.08064 11.2692 3.7098 12.2684L3.85927 12.5055L3.2245 14.8184L5.6022 14.1963ZM1.40967 16.6103L2.48207 12.7023C1.82069 11.5587 1.47274 10.2612 1.47316 8.93198C1.4749 4.77362 4.86541 1.39062 9.03185 1.39062C11.0537 1.39165 12.9514 2.17696 14.3787 3.60248C15.8059 5.02801 16.5912 6.92283 16.5904 8.93803C16.5886 13.0961 13.1976 16.4797 9.03175 16.4797H9.02846C7.76354 16.4792 6.52061 16.1625 5.41656 15.5616L1.40967 16.6103Z"
                  fill="#B3B3B3"
                />
              </g>
              <path
                d="M1.33203 16.5322L2.40443 12.6242C1.74192 11.4778 1.39392 10.1773 1.39552 8.85385C1.39727 4.6955 4.78778 1.3125 8.95421 1.3125C10.976 1.31353 12.8738 2.09883 14.301 3.52436C15.7283 4.94988 16.5135 6.84471 16.5128 8.8599C16.511 13.018 13.1199 16.4016 8.95411 16.4016H8.95082C7.6859 16.4011 6.44297 16.0843 5.33893 15.4835L1.33203 16.5322Z"
                fill="white"
              />
              <path
                d="M8.95623 2.58693C5.49083 2.58693 2.67263 5.39871 2.67139 8.85482C2.66969 10.035 3.00266 11.1915 3.63182 12.1908L3.78129 12.4279L3.14652 14.7409L5.52432 14.1186L5.75392 14.2543C6.71825 14.8256 7.82394 15.1276 8.9515 15.1282H8.95387C12.4166 15.1282 15.2348 12.3162 15.2361 8.85984C15.2388 8.03604 15.0776 7.21991 14.7621 6.45869C14.4465 5.69747 13.9828 5.00629 13.3978 4.42516C12.816 3.84084 12.1239 3.37751 11.3615 3.06198C10.5991 2.74645 9.78157 2.58498 8.95623 2.58693Z"
                fill="url(#paint0_linear_811_8017)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.06495 5.70115C6.92339 5.38729 6.77443 5.38094 6.63996 5.3755L6.27794 5.37109C6.15199 5.37109 5.94735 5.41826 5.77435 5.60692C5.60135 5.79558 5.11328 6.25155 5.11328 7.17897C5.11328 8.10639 5.79007 9.00253 5.88438 9.12844C5.97868 9.25435 7.1909 11.2182 9.11062 11.9738C10.7059 12.6017 11.0305 12.4768 11.377 12.4454C11.7234 12.414 12.4944 11.9894 12.6516 11.5493C12.8089 11.1091 12.809 10.732 12.7619 10.6531C12.7147 10.5743 12.5888 10.5274 12.3997 10.4331C12.2107 10.3387 11.2823 9.88278 11.1092 9.81983C10.9361 9.75687 10.8103 9.7256 10.6842 9.91426C10.5582 10.1029 10.1967 10.5273 10.0865 10.6531C9.97623 10.7789 9.8662 10.7947 9.67718 10.7005C9.48816 10.6063 8.87999 10.4071 8.15841 9.76497C7.59699 9.26532 7.21802 8.64828 7.10769 8.45972C6.99736 8.27116 7.09598 8.16903 7.19069 8.07511C7.27545 7.99063 7.37951 7.85497 7.47413 7.74495C7.56874 7.63494 7.59987 7.55629 7.66274 7.43069C7.72561 7.30508 7.69428 7.19476 7.64702 7.10053C7.59977 7.0063 7.23281 6.07396 7.06495 5.70115Z"
                fill="white"
              />
            </g>
            <defs>
              <filter
                id="filter0_f_811_8017"
                x="-5.65233"
                y="-5.67137"
                width="29.3047"
                height="29.3437"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="3.531"
                  result="effect1_foregroundBlur_811_8017"
                />
              </filter>
              <linearGradient
                id="paint0_linear_811_8017"
                x1="8.82586"
                y1="3.33953"
                x2="8.88931"
                y2="14.0569"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#57D163" />
                <stop offset="1" stop-color="#23B33A" />
              </linearGradient>
              <clipPath id="clip0_811_8017">
                <rect width="18" height="18" fill="white" />
              </clipPath>
            </defs>
          </svg>
          Share
        </button>
        <button
          class="btn-link btn-link-primary d-flex align-items-center text-body2 gap-1 p-0"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.75 13.5C6.3375 13.5 5.98438 13.3531 5.69062 13.0594C5.39687 12.7656 5.25 12.4125 5.25 12V3C5.25 2.5875 5.39687 2.23438 5.69062 1.94062C5.98438 1.64687 6.3375 1.5 6.75 1.5H13.5C13.9125 1.5 14.2656 1.64687 14.5594 1.94062C14.8531 2.23438 15 2.5875 15 3V12C15 12.4125 14.8531 12.7656 14.5594 13.0594C14.2656 13.3531 13.9125 13.5 13.5 13.5H6.75ZM3.75 16.5C3.3375 16.5 2.98438 16.3531 2.69062 16.0594C2.39687 15.7656 2.25 15.4125 2.25 15V4.5H3.75V15H12V16.5H3.75Z"
              fill="#004B64"
            />
          </svg>
          Share
        </button>
      </div> -->
        </div>
        <div
          *ngIf="
            orderData?.state?.code === orderStateCode['admin-pending'] ||
            orderData?.state?.code === orderStateCode['requested'] ||
            orderData?.state?.code === orderStateCode['estimated']
          "
          class="header-actions d-flex align-item-center gap-2"
        >
          <button
            class="btn-link btn-link-primary d-flex align-items-center text-body2 gap-1 p-0"
            (click)="openPickupModal(item, i)"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.25 15.75V12.5625L12.15 2.68125C12.3 2.54375 12.4656 2.4375 12.6469 2.3625C12.8281 2.2875 13.0188 2.25 13.2188 2.25C13.4188 2.25 13.6125 2.2875 13.8 2.3625C13.9875 2.4375 14.15 2.55 14.2875 2.7L15.3188 3.75C15.4688 3.8875 15.5781 4.05 15.6469 4.2375C15.7156 4.425 15.75 4.6125 15.75 4.8C15.75 5 15.7156 5.19063 15.6469 5.37188C15.5781 5.55313 15.4688 5.71875 15.3188 5.86875L5.4375 15.75H2.25ZM13.2 5.85L14.25 4.8L13.2 3.75L12.15 4.8L13.2 5.85Z"
                fill="#004B64"
              />
            </svg>
            Edit
          </button>
          <button
            class="btn-link btn-link-danger d-flex align-items-center text-body2 gap-1 p-0"
            (click)="deleteSubOrder(item._id)"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.8335 17.5C5.37516 17.5 4.9828 17.3368 4.65641 17.0104C4.33002 16.684 4.16683 16.2917 4.16683 15.8333V5C3.93072 5 3.7328 4.92014 3.57308 4.76042C3.41336 4.60069 3.3335 4.40278 3.3335 4.16667C3.3335 3.93056 3.41336 3.73264 3.57308 3.57292C3.7328 3.41319 3.93072 3.33333 4.16683 3.33333H7.50016C7.50016 3.09722 7.58002 2.89931 7.73975 2.73958C7.89947 2.57986 8.09738 2.5 8.3335 2.5H11.6668C11.9029 2.5 12.1009 2.57986 12.2606 2.73958C12.4203 2.89931 12.5002 3.09722 12.5002 3.33333H15.8335C16.0696 3.33333 16.2675 3.41319 16.4272 3.57292C16.587 3.73264 16.6668 3.93056 16.6668 4.16667C16.6668 4.40278 16.587 4.60069 16.4272 4.76042C16.2675 4.92014 16.0696 5 15.8335 5V15.8333C15.8335 16.2917 15.6703 16.684 15.3439 17.0104C15.0175 17.3368 14.6252 17.5 14.1668 17.5H5.8335ZM8.3335 14.1667C8.56961 14.1667 8.76752 14.0868 8.92725 13.9271C9.08697 13.7674 9.16683 13.5694 9.16683 13.3333V7.5C9.16683 7.26389 9.08697 7.06597 8.92725 6.90625C8.76752 6.74653 8.56961 6.66667 8.3335 6.66667C8.09738 6.66667 7.89947 6.74653 7.73975 6.90625C7.58002 7.06597 7.50016 7.26389 7.50016 7.5V13.3333C7.50016 13.5694 7.58002 13.7674 7.73975 13.9271C7.89947 14.0868 8.09738 14.1667 8.3335 14.1667ZM11.6668 14.1667C11.9029 14.1667 12.1009 14.0868 12.2606 13.9271C12.4203 13.7674 12.5002 13.5694 12.5002 13.3333V7.5C12.5002 7.26389 12.4203 7.06597 12.2606 6.90625C12.1009 6.74653 11.9029 6.66667 11.6668 6.66667C11.4307 6.66667 11.2328 6.74653 11.0731 6.90625C10.9134 7.06597 10.8335 7.26389 10.8335 7.5V13.3333C10.8335 13.5694 10.9134 13.7674 11.0731 13.9271C11.2328 14.0868 11.4307 14.1667 11.6668 14.1667Z"
                fill="#F04438"
              />
            </svg>
            DELETE
          </button>
        </div>
      </div>
      <!-- header end here -->
      <!-- Pickup table start here -->
      <bst-frontend-view-product-diff
        [productDifferences]="item?.productDifferences"
      ></bst-frontend-view-product-diff>
      <ng-container *ngFor="let delivery of item.deliveries; let di = index">
        <!-- Pickup table end here -->
        <!-- header start here -->
        <div
          class="location-header p-3 d-flex align-item-center justify-content-between"
        >
          <div class="location-header-left d-flex align-item-center gap-2">
            <div class="location-name d-flex gap-1">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="12" r="12" fill="#FEE4E2" />
                <path
                  d="M11.9987 11.6663C11.5567 11.6663 11.1327 11.4907 10.8202 11.1782C10.5076 10.8656 10.332 10.4417 10.332 9.99967C10.332 9.55765 10.5076 9.13372 10.8202 8.82116C11.1327 8.5086 11.5567 8.33301 11.9987 8.33301C12.4407 8.33301 12.8646 8.5086 13.1772 8.82116C13.4898 9.13372 13.6654 9.55765 13.6654 9.99967C13.6654 10.2185 13.6223 10.4353 13.5385 10.6375C13.4547 10.8397 13.332 11.0234 13.1772 11.1782C13.0224 11.3329 12.8387 11.4557 12.6365 11.5395C12.4343 11.6232 12.2176 11.6663 11.9987 11.6663ZM11.9987 5.33301C10.761 5.33301 9.57404 5.82467 8.69887 6.69984C7.8237 7.57501 7.33203 8.762 7.33203 9.99967C7.33203 13.4997 11.9987 18.6663 11.9987 18.6663C11.9987 18.6663 16.6654 13.4997 16.6654 9.99967C16.6654 8.762 16.1737 7.57501 15.2985 6.69984C14.4234 5.82467 13.2364 5.33301 11.9987 5.33301Z"
                  fill="#F04438"
                />
              </svg>
              <p class="text-body1 font-bold">
                {{ delivery?.address?.companyName }}
              </p>
            </div>
            <!-- <div class="header-actions d-flex align-item-center gap-2">
        <button
          class="btn-link btn-link-primary d-flex align-items-center text-body2 gap-1 p-0"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_811_8017)">
              <g filter="url(#filter0_f_811_8017)">
                <path
                  d="M5.6022 14.1963L5.8318 14.332C6.79613 14.9032 7.90181 15.2054 9.02938 15.2059H9.03175C12.4945 15.2059 15.3126 12.3938 15.314 8.93752C15.3146 7.26263 14.6618 5.68761 13.4757 4.50283C12.8939 3.91853 12.2018 3.45521 11.4394 3.13967C10.677 2.82414 9.85953 2.66267 9.03421 2.66461C5.56881 2.66461 2.75061 5.47639 2.74937 8.93249C2.74767 10.1127 3.08064 11.2692 3.7098 12.2684L3.85927 12.5055L3.2245 14.8184L5.6022 14.1963ZM1.40967 16.6103L2.48207 12.7023C1.82069 11.5587 1.47274 10.2612 1.47316 8.93198C1.4749 4.77362 4.86541 1.39062 9.03185 1.39062C11.0537 1.39165 12.9514 2.17696 14.3787 3.60248C15.8059 5.02801 16.5912 6.92283 16.5904 8.93803C16.5886 13.0961 13.1976 16.4797 9.03175 16.4797H9.02846C7.76354 16.4792 6.52061 16.1625 5.41656 15.5616L1.40967 16.6103Z"
                  fill="#B3B3B3"
                />
              </g>
              <path
                d="M1.33203 16.5322L2.40443 12.6242C1.74192 11.4778 1.39392 10.1773 1.39552 8.85385C1.39727 4.6955 4.78778 1.3125 8.95421 1.3125C10.976 1.31353 12.8738 2.09883 14.301 3.52436C15.7283 4.94988 16.5135 6.84471 16.5128 8.8599C16.511 13.018 13.1199 16.4016 8.95411 16.4016H8.95082C7.6859 16.4011 6.44297 16.0843 5.33893 15.4835L1.33203 16.5322Z"
                fill="white"
              />
              <path
                d="M8.95623 2.58693C5.49083 2.58693 2.67263 5.39871 2.67139 8.85482C2.66969 10.035 3.00266 11.1915 3.63182 12.1908L3.78129 12.4279L3.14652 14.7409L5.52432 14.1186L5.75392 14.2543C6.71825 14.8256 7.82394 15.1276 8.9515 15.1282H8.95387C12.4166 15.1282 15.2348 12.3162 15.2361 8.85984C15.2388 8.03604 15.0776 7.21991 14.7621 6.45869C14.4465 5.69747 13.9828 5.00629 13.3978 4.42516C12.816 3.84084 12.1239 3.37751 11.3615 3.06198C10.5991 2.74645 9.78157 2.58498 8.95623 2.58693Z"
                fill="url(#paint0_linear_811_8017)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.06495 5.70115C6.92339 5.38729 6.77443 5.38094 6.63996 5.3755L6.27794 5.37109C6.15199 5.37109 5.94735 5.41826 5.77435 5.60692C5.60135 5.79558 5.11328 6.25155 5.11328 7.17897C5.11328 8.10639 5.79007 9.00253 5.88438 9.12844C5.97868 9.25435 7.1909 11.2182 9.11062 11.9738C10.7059 12.6017 11.0305 12.4768 11.377 12.4454C11.7234 12.414 12.4944 11.9894 12.6516 11.5493C12.8089 11.1091 12.809 10.732 12.7619 10.6531C12.7147 10.5743 12.5888 10.5274 12.3997 10.4331C12.2107 10.3387 11.2823 9.88278 11.1092 9.81983C10.9361 9.75687 10.8103 9.7256 10.6842 9.91426C10.5582 10.1029 10.1967 10.5273 10.0865 10.6531C9.97623 10.7789 9.8662 10.7947 9.67718 10.7005C9.48816 10.6063 8.87999 10.4071 8.15841 9.76497C7.59699 9.26532 7.21802 8.64828 7.10769 8.45972C6.99736 8.27116 7.09598 8.16903 7.19069 8.07511C7.27545 7.99063 7.37951 7.85497 7.47413 7.74495C7.56874 7.63494 7.59987 7.55629 7.66274 7.43069C7.72561 7.30508 7.69428 7.19476 7.64702 7.10053C7.59977 7.0063 7.23281 6.07396 7.06495 5.70115Z"
                fill="white"
              />
            </g>
            <defs>
              <filter
                id="filter0_f_811_8017"
                x="-5.65233"
                y="-5.67137"
                width="29.3047"
                height="29.3437"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="3.531"
                  result="effect1_foregroundBlur_811_8017"
                />
              </filter>
              <linearGradient
                id="paint0_linear_811_8017"
                x1="8.82586"
                y1="3.33953"
                x2="8.88931"
                y2="14.0569"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#57D163" />
                <stop offset="1" stop-color="#23B33A" />
              </linearGradient>
              <clipPath id="clip0_811_8017">
                <rect width="18" height="18" fill="white" />
              </clipPath>
            </defs>
          </svg>
          Share
        </button>
        <button
          class="btn-link btn-link-primary d-flex align-items-center text-body2 gap-1 p-0"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.75 13.5C6.3375 13.5 5.98438 13.3531 5.69062 13.0594C5.39687 12.7656 5.25 12.4125 5.25 12V3C5.25 2.5875 5.39687 2.23438 5.69062 1.94062C5.98438 1.64687 6.3375 1.5 6.75 1.5H13.5C13.9125 1.5 14.2656 1.64687 14.5594 1.94062C14.8531 2.23438 15 2.5875 15 3V12C15 12.4125 14.8531 12.7656 14.5594 13.0594C14.2656 13.3531 13.9125 13.5 13.5 13.5H6.75ZM3.75 16.5C3.3375 16.5 2.98438 16.3531 2.69062 16.0594C2.39687 15.7656 2.25 15.4125 2.25 15V4.5H3.75V15H12V16.5H3.75Z"
              fill="#004B64"
            />
          </svg>
          Share
        </button>
      </div> -->
          </div>
        </div>
        <!-- header end here -->
        <!-- Delivery table start here -->
        <div class="table-wrapper">
          <table class="delivery-table">
            <thead>
              <tr>
                <th>Address</th>
                <th>Product &amp; Size</th>
                <th>Weight (KG)</th>
                <th>Qty (Box)</th>
                <th>Delivery Name &amp; Number</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let it of delivery?.items; let itt = index">
                <td
                  *ngIf="itt === 0"
                  [attr.rowspan]="delivery.items.length + 1"
                  class="godown-cell"
                >
                  <p class="text-body2 font-bold">
                    {{ delivery?.address?.companyName }}
                  </p>
                  <p class="text-body2">
                    {{ delivery?.address?.locality }}, India
                  </p>
                </td>
                <td>
                  <span>{{ it?.product?.name }}</span>
                  <span *ngIf="it?.product?.subItems?.name">
                    {{ it?.product?.subItems?.name }}</span
                  >
                </td>
                <td>{{ it?.planned?.showWeight }}</td>
                <td>{{ it?.planned?.showQTY }}</td>
                <td
                  *ngIf="itt === 0"
                  [attr.rowspan]="delivery.items.length + 1"
                  class="delivery-contact"
                >
                  <p class="text-body2 font-bold">
                    {{ delivery?.address?.contactName }}
                  </p>
                  <a
                    href="tel:{{ delivery?.address?.contactNumber }}"
                    class="btn-link btn-link-primary"
                    >{{ delivery?.address?.contactNumber }}</a
                  >
                </td>
              </tr>
              <tr class="total-row">
                <td><strong>Total</strong></td>
                <td>
                  <strong>{{ totalWeight(delivery) | number }}</strong>
                </td>
                <td>
                  <strong>{{ totalQty(delivery) | number }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
      <!-- Delivery table end here -->
    </div>
  </ng-container>
</ng-container>
<!-- Sub order end here -->
<div
  *ngIf="orderData?.type !== 'full-load'"
  [ngClass]="orderData?.sharedDelivery ? 'd-none' : 'd-block'"
  class="add-pickup-card d-flex align-item-center justify-content-center pt-5"
>
  <div
    class="d-flex flex-column gap-3 align-item-center justify-content-center text-center"
  >
    <div
      class="add-pickup-card-image d-flex justify-content-center align-item-center"
    >
      <img src="assets/images/truck.png" alt="images" />
    </div>
    <h4 class="font-extrabold">Add Delivery location</h4>
    <button class="btn btn-primary" (click)="openDeliveryModal()">
      Add Delivery Location
    </button>
  </div>
</div>
<div
  [ngClass]="orderData?.subOrders?.length > 0 ? 'd-none' : 'd-block'"
  class="add-pickup-card d-flex align-item-center justify-content-center pt-5"
>
  <div
    class="d-flex flex-column gap-3 align-item-center justify-content-center text-center"
  >
    <div
      class="add-pickup-card-image d-flex justify-content-center align-item-center"
    >
      <img src="assets/images/truck.png" alt="images" />
    </div>
    <h4 class="font-extrabold">Add Pickup location</h4>
    <button class="btn btn-primary" (click)="openPickupModal()">
      Add Pickup Location
    </button>
  </div>
</div>
<div class="text-center mt-4">
  <!-- 
</div>
<div class="text-center mt-4">
  <button class="btn btn-primary" (click)="openAddEstimateModal()">
    Add Estimate
  </button>
</div>
<div class="text-center mt-4">
  <button class="btn btn-primary" (click)="openAssignTruckModal()">
    Assign Truck
  </button>
</div>
<div class="text-center mt-4">
  <button class="btn btn-primary" (click)="openAssignDriverModal()">
    Assign Driver
  </button>
</div>
<div class="text-center mt-4">
  <button class="btn btn-primary" (click)="openVehicleAssignModal()">
    Vehicle Assign Details
  </button>
</div>
<div class="text-center mt-4">
  <button class="btn btn-primary" (click)="openReadyToDispatchModal()">
    Ready To Dispatch
  </button>
</div>
<div class="text-center mt-4">
  <button class="btn btn-primary" (click)="openDeliverModal()">
    Ready To Dispatch
  </button>
</div>
<div class="text-center mt-4">
  <button class="btn btn-primary" (click)="openConfirmPaymentModal()">
    Confirm Payment
  </button>
</div> -->
</div>
